import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

// import { DataGrid } from '@mui/x-data-grid';

function Statemas() {
  const [CountryData, setCountryData] = useState(null);
  const [StateData, setStateData] = useState(null);
  const [SlelectedCountry, setSlelectedCountry] = useState(null);
  const [flg, setflg] = useState(false);
  const swal = useSwalWrapper()
const fetchCountryData = useCallback(()=>{
  setCountryData(null)
  jwtAuthAxios.get(`master/helper?country=1`).then(res=>{
    setCountryData(res.data.data.COUNTRY)
  })
})
useEffect(()=>{
  fetchCountryData()
},[])

useEffect(()=>{
  console.log(SlelectedCountry);
  SlelectedCountry && jwtAuthAxios.get(`master/helper?state=${SlelectedCountry}`).then(res=>{
    setStateData(res.data.data.STATE)
  })
},[SlelectedCountry])

const formEditSubmitHandler = async(row,iid)=>{
  const {FL_STATE_CD,FL_COUNTRY_CD} = row
  // console.log(row,document.getElementById(`detail-a-${index}`).value,document.getElementById(`detail-b-${index}`).value);
  // console.log({ FL_STATE_CD:FL_STATE_CD,
  //   FL_COUNTRY_NAME : document.getElementById(`${iid}-a`).value,
  //   FL_COUNTRY_CODE : document.getElementById(`${iid}-b`).value,
  //   FL_COUNTRY_SHORT : document.getElementById(`${iid}-c`).value
  // });
  // return
  await jwtAuthAxios.post('master/stateaddEdit',
  {
    FL_STATE_CODE  : document.getElementById(`${iid}-a`).value,
    FL_STATE_NAME: document.getElementById(`${iid}-b`).value,
    FL_COUNTRY_CD : document.getElementById(`${iid}-c`).value,
    FL_STATE_CD
  }).then(res =>{
    swal.fire({
      icon:'success',
      text:res.data.message,
    })
    // callback()
    }).catch(()=>{
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });
  })
}

  return (<>
  <Grid container>
      <Grid item xs={6}>
        <h2>State master</h2>
      </Grid>
      <Grid item xs={6}>
      <FormControl sx={{mb:2,display: 'block',marginLeft: 'auto',width: 'fit-content'}}>
        <InputLabel>Select Country</InputLabel>
        <Select sx={{width:200}} value={SlelectedCountry} onChange={(e)=>{setSlelectedCountry(e.target.value)}}>
          {CountryData?.map((country) => (
            <MenuItem key={country.FL_COUNTRY_CD} value={country.FL_COUNTRY_CD}>
              {country.FL_COUNTRY_NAME}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </Grid>
      </Grid>
    {(SlelectedCountry && CountryData?.length >0 )? 
      <TableContainer  component={Paper}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>CODE</TableCell>
              <TableCell>NAME</TableCell>
              <TableCell>Country CODE</TableCell>
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {StateData?.map((Data,index)=> 
          <TableRow key={index}>
            <TableCell>{Data.FL_STATE_CD}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-a`} defaultValue={Data.FL_STATE_CODE} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-b`} defaultValue={Data.FL_STATE_NAME} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-c`} defaultValue={Data.FL_COUNTRY_CD} /></TableCell>
              <TableCell>
                <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler(Data,`detail-${Data.FL_STATE_CD}`)}} color='primary'>Save</LoadingButton>
                <LoadingButton variant='contained' size='small' sx={{ ml: 2 }} onClick={()=>{jwtAuthAxios.get('master/deletestatesmas/'+Data.FL_STATE_CD).then(()=> {StateData([])})}} color='error'>Delete</LoadingButton>
              </TableCell>
            </TableRow>)
          }
          <TableRow>
            <TableCell>{'-'}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-a`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-b`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-c`}  /></TableCell>
              {/* <TableCell><TextField size='small' fullWidth id={`detail-${selectedParamType.FL_STATE_CD}-d`} defaultValue={selectedParamType.FL_STATE_CD} /></TableCell> */}
              {/* <TableCell>{Data.FL_COUNTRY_CODE}</TableCell>
              <TableCell>{Data.FL_COUNTRY_NAME}</TableCell>
              <TableCell>{Data.FL_COUNTRY_SHORT}</TableCell> */}
              <TableCell>
              <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler({FL_STATE_CD:null},`detail-new`)}} color='primary'>Save</LoadingButton>
                          {/* <LoadingButton variant='contained' size='small' sx={{ ml: 2 }} onClick={()=>{jwtAuthAxios.get('master/deleteEditsynonymsmas/'+selectedParamType.FL_SYNOID).then(()=> {handleSynonumParams(row, setParamsData); setOpen(!open)})}} color='error'>Delete</LoadingButton> */}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer> :<TableSkeleton cols={7} />}</>
  );
}



Statemas.Modulename = 'Statemas';

export default Statemas;
